import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getReportsFinanceByDestination(companyId, query) {
	return dataTransferWrap(
		ModulesMap.REPORTS_FINANCE_BY_DESTINATION,dtConfig[ModulesMap.REPORTS_FINANCE_BY_DESTINATION].getReportsFinanceByDestination,
		{
			urlParams: {
				companyId: companyId,
			},
			params: query,
		},
	)
}

export default {
	getReportsFinanceByDestination,
}
